import { useState, useCallback, useEffect } from 'react'
import API from "@api/api";
import { useNavigate } from "react-router-dom"

export default function usePickedImageList(projectId) {
	const navigate = useNavigate()
	const [pickedList, setPickedList] = useState([])
	const [groupedPickedList, setGroupedPickedList] = useState([])
	const [pickedCount, setPickedCount] = useState(0) // ✅ 新增：统计 picked 为 true 的数量

	const getPickedImageList = useCallback(async () => {
		if (!projectId) return
		try {
			const res = await API.batchListPickedResult({
				projectId,
				picked: true,
			})
			if (res.code === 0) {
				const data = res.data || []
				console.log('data', data)

				setPickedList(data)

				// ✅ 统计 picked=true 的数量
				const count = data.filter(item => item?.picked === true).length
				setPickedCount(count)

				// 分组逻辑：按 skuId 聚合
				const grouped = data.reduce((acc, item) => {
					const skuId = item.skuId
					if (!acc[skuId]) acc[skuId] = []
					acc[skuId].push(item)
					return acc
				}, {})

				setGroupedPickedList(Object.values(grouped))
			} else if (res.code === -5067) {
				navigate('/home/product/batchImages')
			}
		} catch (err) {
			console.error('getPickedImageList error:', err)
		}
	}, [projectId])

	useEffect(() => {
		getPickedImageList()
	}, [getPickedImageList])

	// 输出
	return {
		pickedList,          // 一维数组原始数据
		groupedPickedList,   // 二维数组
		pickedCount,         // picked=true 的数量
		refreshPickedList: getPickedImageList, // 手动刷新
	}
}
